import { render, staticRenderFns } from "./AncillaryReissueSearchLegBody.vue?vue&type=template&id=2bbf7d42&scoped=true"
import script from "./AncillaryReissueSearchLegBody.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegBody.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegBody.vue?vue&type=style&index=0&id=2bbf7d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf7d42",
  null
  
)

export default component.exports